module.exports = __webpack_public_path__ + "img/voucher_active.5f6a17af.svg";